<wsb-modal
  class="custom-modal-width"
  cancelButtonEnable="true"
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  title="{{ title | translate }}"
  (primary)="checkPwd()"
  primaryButtonText="common_save"
  [primaryDisabled]="!checkPassword.value"
>
  <div body>
    <div class="mb-5" [innerHtml]="label | translate"></div>
    <div class="d-flex align-items-center">
      <span class="col-5 ps-0" translate>privacy_modal_enter_password</span>
      <input [type]="'password'" class="form-control col-5 ms-3" id="current-password" [formControl]="checkPassword" />
    </div>
  </div>
</wsb-modal>
